import { defineMessages } from '@/i18n';

export const activationTabsMessages = defineMessages({
  new: 'platform.app.activations.tab.new',
  dashboard: 'platform.app.activations.tab.dashboard',
  exhibitors: 'platform.app.activations.tab.exhibitors',
  listings: 'platform.app.activations.tab.listings',
  profile: 'platform.app.activations.tab.profile',
  info: 'platform.app.activations.tab.info',
  transactions: 'platform.app.activations.tab.transactions',
  style: 'platform.app.activations.tab.style',
  legal: 'platform.app.activations.tab.legal',
  content: 'platform.app.activations.tab.content',
  settings: 'platform.app.activations.tab.settings',
  viewingRooms: 'platform.app.activations.tab.viewingRooms',
  viewingRoomsArtBasel: 'platform.app.activations.tab.viewingRoomsArtBasel',
  audience: 'platform.app.activations.tab.audience',
});

export const activationStyleMessages = defineMessages({
  openingTimeSloganTitle: 'platform.app.activations.style.openingTimeSlogan.title',
  openingTimeSloganDescription: 'platform.app.activations.style.openingTimeSlogan.description',
  openingTimeSloganLabel: 'platform.app.activations.style.openingTimeSlogan.label',
  openingTimeSloganPlaceholder: 'platform.app.activations.style.openingTimeSlogan.placeholder',
  subtitle: 'platform.app.activations.style.subtitle',
  logoTitle: 'platform.app.activations.style.logo.title',
  logoDescription: 'platform.app.activations.style.logo.description',
  darkLogoTitle: 'platform.app.activations.style.darkLogo.title',
  darkLogoDescription: 'platform.app.activations.style.darkLogo.description',
  desktopBannerTitle: 'platform.app.activations.style.desktopBanner.title',
  desktopBannerDescription: 'platform.app.activations.style.desktopBanner.description',
  mobileBannerTitle: 'platform.app.activations.style.mobileBanner.title',
  mobileBannerDescription: 'platform.app.activations.style.mobileBanner.description',
  emailBannerTitle: 'platform.app.activations.style.emailBanner.title',
  emailBannerDescription: 'platform.app.activations.style.emailBanner.description',
  socialSharingImageTitle: 'platform.app.activations.style.socialSharingImage.title',
  socialSharingImageDescription: 'platform.app.activations.style.socialSharingImage.description',
  socialSharingImageDescriptionArtBasel: 'platform.app.activations.style.socialSharingImage.descriptionArtBasel',
  addImagesLabel: 'platform.app.activations.style.addImages.label',
  preview: 'platform.app.activations.style.preview',
  tagline: 'platform.app.activations.style.tagline',
  updatedSuccessfully: 'platform.app.activations.style.updatedSuccessfully',
  toastTitle: 'platform.app.activations.style.toastTitle',
  toastTitleError: 'platform.app.activations.style.toastTitleError',
});

export const activationSettingsMessages = defineMessages({
  title: 'platform.app.activations.new.title',
  description: 'platform.app.activations.new.description',
  createStorefront: 'platform.app.activations.new.storefront',
  createStorefrontMessage: 'platform.app.activations.settings.storefrontMessage',
  createStorefrontMessageArtBasel: 'platform.app.activations.settings.storefrontMessageArtBasel',
  settingsTitle: 'platform.app.activations.settings.title',
  name: 'platform.app.activations.settings.name',
  storefrontNameLabel: 'platform.app.activations.settings.storefrontNameLabel',
  type: 'platform.app.activations.settings.type',
  storefront: 'platform.app.activations.settings.storefront',
  storefrontArtBasel: 'platform.app.activations.settings.storefrontArtBasel',
  cancel: 'platform.app.activations.settings.cancel',
  create: 'platform.app.activations.settings.create',
  storefrontNameRequired: 'platform.app.activations.settings.unpublish.name.required',
  storefrontNameNotMatch: 'platform.app.activations.settings.unpublish.name.notMatch',
  unpublishing: 'platform.app.activations.settings.unpublish.title',
  unpublishingArtBasel: 'platform.app.activations.settings.unpublish.titleArtBasel',
  unpublishingViewingRoom: 'platform.app.activations.settings.unpublishViewingRoom.title',
  unpublishingViewingRoomArtBasel: 'platform.app.activations.settings.unpublishViewingRoom.titleArtBasel',
  unpublish: 'platform.app.activations.settings.unpublish',
  unpublishBody: 'platform.app.activations.settings.unpublish.body',
  unpublishBodyArtBasel: 'platform.app.activations.settings.unpublish.bodyArtBasel',
  unpublishModalBody: 'platform.app.activations.settings.unpublish.modal.body',
  unpublishModalInputTitle: 'platform.app.activations.settings.unpublish.modal.input.title',
  unpublishModalButtonBack: 'platform.app.activations.settings.unpublish.modal.button.back',
  toastTitle: 'platform.app.activations.settings.unpublish.toastTitle',
  toastDescription: 'platform.app.activations.settings.unpublish.toastDescription',
  nameRequired: 'platform.app.validation.required',
  nameNotAlphanumeric: 'platform.app.linkInBio.settings.validation.nameMustBeAlphanumeric',
  linkInBioDomainInvalid: 'platform.app.linkInBio.settings.validation.invalidSubdomain',
  linkInBioDomainInUseTitle: 'platform.app.linkInBio.settings.validation.subdomainInUseTitle',
  linkInBioDomainInUseMessage: 'platform.app.linkInBio.settings.validation.subdomainInUseMessage',
  nameTooShort: 'platform.app.linkInBio.settings.validation.nameTooShort',
  nameTooLong: 'platform.app.linkInBio.settings.validation.nameTooLong',
  addressRequired: 'platform.app.validation.required',
  currencyRequired: 'platform.app.validation.required',
  storefrontCreated: 'platform.app.activations.settings.storefrontCreated',
  viewingRoomCreatedArtBasel: 'platform.app.activations.settings.viewingRoomCreatedArtBasel',
  storefrontNotCreated: 'platform.app.activations.settings.storefrontNotCreated',
  storefrontNameNotUnique: 'platform.app.activations.settings.storefrontNameNotUnique',
  storefrontSubdomainNotUnique: 'platform.app.activations.settings.storefrontSubdomainNotUnique',
  viewingRoomError: 'platform.app.activations.settings.viewingRoomError',
  viewingRoomErrorDescription: 'platform.app.activations.settings.viewingRoomErrorDescription',
  viewingRoomErrorNameNotUnique: 'platform.app.activations.settings.viewingRoomNameNotUnique',
  viewingRoomErrorSlugNotUnique: 'platform.app.activations.settings.viewingRoomSlugNotUnique',
  storefrontCreateNotice: 'platform.app.activations.settings.storefrontCreateNotice',
  storefrontCreateNoticeArtBasel: 'platform.app.activations.settings.storefrontCreateNoticeArtBasel',
  createdSuccessfully: 'platform.app.activations.settings.createdSuccessfully',
  storefrontUpdated: 'platform.app.activations.settings.storefrontUpdated',
  storefrontNotUpdated: 'platform.app.activations.settings.storefrontNotUpdated',
  updatedSuccessfully: 'platform.app.activations.settings.updatedSuccessfully',
  exhibitors: 'platform.app.activations.settings.exhibitors',
  single: 'platform.app.activations.settings.single',
  singleDescription: 'platform.app.activations.settings.singleDescription',
  singleDescriptionArtBasel: 'platform.app.activations.settings.singleDescriptionArtBasel',
  multiple: 'platform.app.activations.settings.multiple',
  multipleDescription: 'platform.app.activations.settings.multipleDescription',
  multipleDescriptionArtBasel: 'platform.app.activations.settings.multipleDescriptionArtBasel',
  activationType: 'platform.app.activations.settings.activationType',
  activationTypeArtBasel: 'platform.app.activations.settings.activationTypeArtBasel',
  sellersTitle: 'platform.app.activations.settings.sellersTitle',
  websiteLabel: 'platform.app.activations.settings.websiteLabel',
  websiteLabelArtBasel: 'platform.app.activations.settings.websiteLabelArtBasel',
  websiteDescription: 'platform.app.activations.settings.websiteDescription',
  apiOnlyLabel: 'platform.app.activations.settings.apiOnlyLabel',
  apiOnlyLabelArtBasel: 'platform.app.activations.settings.apiOnlyLabelArtBasel',
  apiOnlyDescription: 'platform.app.activations.settings.apiOnlyDescription',
  activationCurrency: 'platform.app.activations.settings.activationCurrency',
  sectorsSectionTitle: 'platform.app.activations.settings.sectors.sectionTitle',
  sectorsSectionSubtitle: 'platform.app.activations.settings.sectors.sectionSubtitle',
});

export const activationLegalMessages = defineMessages({
  exhibitorsTitle: 'platform.app.activations.legal.exhibitors.title',
  buyersTitle: 'platform.app.activations.legal.buyers.title',
  title: 'platform.app.activations.legal.title',
  subtitle: 'platform.app.activations.legal.subtitle',
  exhibitorDescription: 'platform.app.activations.legal.exhibitorDescription',
  exhibitorDescriptionArtBasel: 'platform.app.activations.legal.exhibitorDescriptionArtBasel',
  description: 'platform.app.activations.legal.description',
  descriptionArtBasel: 'platform.app.activations.legal.descriptionArtBasel',
  privacy: 'platform.app.activations.legal.privacy',
  urlDescription: 'platform.app.activations.legal.urlDescription',
  saveLegal: 'platform.app.activations.legal.save',
  savePrivacy: 'platform.app.activations.privacy.save',
  privacyMessage: 'platform.app.activations.legal.privacy.message',
  termsMessage: 'platform.app.activations.legal.terms.message',
  arcualTnc: 'platform.app.activations.home.arcualTnc',
  arcualTncTitle: 'platform.app.activations.home.arcualTnc.title',
  arcualTncSubTitle: 'platform.app.activations.home.arcualTnc.subtitle',
  arcualPp: 'platform.app.activations.home.arcualPp',
  arcualPpTitle: 'platform.app.activations.home.arcualPp.title',
  arcualPpSubTitle: 'platform.app.activations.home.arcualPp.subtitle',
});

export const activationContentMessages = defineMessages({
  aboutTitle: 'platform.app.activations.content.about.title',
  unpublished: 'platform.app.activations.content.unpublished.title',
  unpublishedArtBasel: 'platform.app.activations.content.unpublished.titleArtBasel',
  unpublishedSectionTitle: 'platform.app.activations.content.unpublished.section.title',
  aboutInputTitle: 'platform.app.activations.content.about.input.title',
  helpInputTitle: 'platform.app.activations.content.help.input.title',
  saveAbout: 'platform.app.activations.about.save',
  saveHelp: 'platform.app.activations.help.save',
  saveUnpublished: 'platform.app.activations.unpublished.save',
  aboutMessage: 'platform.app.activations.content.about.save.message',
  helpMessage: 'platform.app.activations.content.help.save.message',
  unpublishedMessage: 'platform.app.activations.content.unpublished.save.message',
  aboutRequired: 'platform.app.activations.content.about.required',
  helpRequired: 'platform.app.activations.content.help.required',
  helpTitle: 'platform.app.activations.content.help.title',
  save: 'platform.app.activations.content.save',
});

export const activationInfoMessages = defineMessages({
  storefrontName: 'platform.app.activations.info.storefrontName',
  url: 'platform.app.activations.info.url',
  legalTerms: 'platform.app.activations.info.legalTerms',
  exhibitorsTNC: 'platform.app.activations.info.exhibitorsTNC',
});

export const activationProfileMessages = defineMessages({
  title: 'platform.app.activations.profile.title',
});

export const activationsHomeMessages = defineMessages({
  name: 'platform.app.activations.home.name',
  artworks: 'platform.app.activations.home.artworks',
  status: 'platform.app.activations.home.status',
  storefronts: 'platform.app.activations.home.storefronts',
  newStorefront: 'platform.app.activations.home.newStorefront',
  newStorefrontArtBasel: 'platform.app.activations.home.newStorefrontArtBasel',
  newViewingRoom: 'platform.app.activations.home.newViewingRoom',
  newViewingRoomArtBasel: 'platform.app.activations.home.newViewingRoomArtBasel',
  newViewingRoomButton: 'platform.app.activations.home.newViewingRoomButton',
  newViewingRoomButtonArtBasel: 'platform.app.activations.home.newViewingRoomButtonArtBasel',
  published: 'platform.app.activations.home.published',
  unpublished: 'platform.app.activations.home.unpublished',
  publish: 'platform.app.activations.home.publish',
  success: 'platform.app.activations.home.success',
  close: 'platform.app.activations.home.close',
  successfully: 'platform.app.activations.home.successfully',
  modalTitle: 'platform.app.activations.home.modalTitle',
  modalDescription: 'platform.app.activations.home.modalDescription',
  visit: 'platform.app.activations.home.visitLabel',
  pendingInvitations: 'platform.app.activations.home.pendingInvitations',
  activeStorefrontsTitle: 'platform.app.activations.home.activeStorefrontsTitle',
  join: 'platform.app.activations.home.join',
  joinStorefrontTitle: 'platform.app.activations.home.joinStorefrontTitle',
  invitationCodeLabel: 'platform.app.activations.home.invitationCodeLabel',
  joinModalButton: 'platform.app.activations.home.joinModalButton',
  cancelModalButton: 'platform.app.activations.home.cancelModalButton',
  storefrontsAndViewingRooms: 'platform.app.activations.home.storefrontsAndViewingRooms',
  storefrontsAndViewingRoomsArtBasel: 'platform.app.activations.home.storefrontsAndViewingRoomsArtBasel',
  myStorefronts: 'platform.app.activations.home.myStorefronts',
  myStorefrontsArtBasel: 'platform.app.activations.home.myStorefrontsArtBasel',
  exhibitionsAndFairs: 'platform.app.activations.home.exhibitionsAndFairs',
});

export const activationsArtworksMessages = defineMessages({
  artist: 'platform.app.activations.artworks.artist',
  listings: 'platform.app.activations.artworks.listings',
  itemDescription: 'platform.app.activations.artworks.itemDescription',
  add: 'platform.app.activations.artworks.add',
  listItems: 'platform.app.activations.artworks.listItems',
  listItemsCta: 'platform.app.activations.artworks.listItemsCta',
  qrLabelsCta: 'platform.app.activations.artworks.qrLabelsCta',
  exhibitorLabelCta: 'platform.app.activations.artworks.exhibitorLabelCta',
  toArtworks: 'platform.app.activations.artworks.toArtworks',
  title: 'platform.app.activations.artworks.title',
  listing: 'platform.app.activations.artworks.listing',
  listed: 'platform.app.activations.artworks.listed',
  unlisted: 'platform.app.activations.artworks.unlisted',
  price: 'platform.app.activations.artworks.price',
  status: 'platform.app.activations.artworks.status',
  removeListing: 'platform.app.activations.artworks.remove',
  modalTitle: 'platform.app.activations.artworks.modal.title',
  modalDescription: 'platform.app.activations.artworks.modal.description',
  close: 'platform.app.activations.artworks.close',
  noArtworks: 'platform.app.activations.artworks.noArtworks',
  noItemsCta: 'platform.app.activations.artworks.noArtworksCta',
  addItem: 'platform.app.activations.artworks.addItem',
  unlistedArtwork: 'platform.app.activations.artworks.UnlistedArtwork',
  success: 'platform.app.activations.artworks.success',
  loadMore: 'platform.app.activations.artworks.loadMore',
  resultCountLabel: 'platform.app.activations.artworks.resultCountLabel',
  reorderToggle: 'platform.app.activations.artworks.reorderToggle',
  sector: 'platform.app.invitations.sector',
  sectorsNotAssigned: 'platform.app.invitations.sectorsNotAssigned',
});

export const activationsDashboardMessages = defineMessages({
  hide: 'platform.app.activations.dashboard.hide',
  currency: 'platform.app.activations.dashboard.currency',
  currencyDescription: 'platform.app.activations.dashboard.currencyDescription',
  save: 'platform.app.activations.dashboard.save',
  storefrontQRLabelButton: 'platform.app.activations.dashboard.storefrontQRLabelButton',
  storefrontQRLabelButtonArtBasel: 'platform.app.activations.dashboard.storefrontQRLabelButtonArtBasel',
  viewingRoomQRLabelButton: 'platform.app.activations.dashboard.viewingRoomQRLabelButton',
  viewingRoomQRLabelButtonArtBasel: 'platform.app.activations.dashboard.viewingRoomQRLabelButtonArtBasel',
});

export const invitationsMessages = defineMessages({
  welcome: 'platform.app.invitations.welcome',
  welcomeDescription: 'platform.app.invitations.welcomeDescription',
  invitation: 'platform.app.invitations.invitation',
  close: 'platform.app.invitations.close',
  agree: 'platform.app.invitations.agree',
  tnc: 'platform.app.invitations.tnc',
  join: 'platform.app.invitations.join',
  accept: 'platform.app.invitations.accept',
  reject: 'platform.app.invitations.reject',
  acceptInvitation: 'platform.app.invitations.acceptInvitation',
  acceptInvitationMessage: 'platform.app.invitations.acceptInvitationMessage',
  dashboardTitle: 'platform.app.invitations.dashboardTitle',
  detailsTitle: 'platform.app.invitations.detailsTitle',
  emptyStateTitle: 'platform.app.invitations.emptyStateTitle',
  emptyStateDescription: 'platform.app.invitations.emptyStateDescription',
  premiumUpgradeTitle: 'platform.app.invitations.premiumUpgradeTitle',
  premiumUpgradeDescription: 'platform.app.invitations.premiumUpgradeDescription',
  upgradeButtonLabel: 'platform.app.invitations.upgradeButtonLabel',
  upgradeButtonUrl: 'platform.app.invitations.upgradeButtonUrl',
});

export const exhibitorMessages = defineMessages({
  results: 'platform.app.common.resultsCount',
  exhibitor: 'platform.app.invitations.exhibitor',
  status: 'platform.app.invitations.status',
  listings: 'platform.app.invitations.listings',
  sectors: 'platform.app.invitations.sectors',
  sectorsNotAssigned: 'platform.app.invitations.sectorsNotAssigned',
  joined: 'platform.app.invitations.joined',
  pending: 'platform.app.invitations.pending',
  rejected: 'platform.app.invitations.rejected',
  exportButton: 'platform.app.invitations.exportButton',
  createButton: 'platform.app.invitations.createButton',
  QRLabelButton: 'platform.app.invitations.QRLabelButton',
  noExhibitorsTitle: 'platform.app.invitations.noExhibitorsTitle',
  noExhibitorsDescription: 'platform.app.invitations.noExhibitorsDescription',
  createModalTitle: 'platform.app.invitations.createModalTitle',
  createModalSubtitle: 'platform.app.invitations.createModalSubtitle',
  amountLabel: 'platform.app.invitations.amountLabel',
  back: 'platform.app.invitations.back',
  createCodes: 'platform.app.invitations.createCodes',
  selected: 'platform.app.invitations.selected',
  newestFirst: 'platform.app.invitations.newestFirst',
  oldestFirst: 'platform.app.invitations.oldestFirst',
  openInvitation: 'platform.app.invitations.openInvitation',
  invitationCode: 'platform.app.invitations.invitationCode',
  invitationURL: 'platform.app.invitations.invitationURL',
  copiedToClipboard: 'platform.app.invitations.copiedToClipboard',
  modalErrorMessage: 'platform.app.invitations.modalErrorMessage',
  invalidInvitationCode: 'platform.app.invitations.invalidInvitationCode',
  acceptErrorMessage: 'platform.app.invitations.acceptErrorMessage',
  statusAccepted: 'platform.app.invitations.statusAccepted',
  statusPending: 'platform.app.invitations.statusPending',
  statusRejected: 'platform.app.invitations.statusRejected',
  exportError: 'platform.app.invitations.exportError',
  exhibitorSectorsSubtitle: 'platform.app.invitations.sectors.sectionSubtitle',
  noSectorsSelected: 'platform.app.invitations.sectors.noneSelectedWarning',
  cancel: 'actions.cancel',
  save: 'actions.save',
  close: 'actions.close',
  makeSectorDefault: 'platform.app.invitations.sectors.makeDefault',
  sectorIsDefault: 'platform.app.invitations.sectors.default',
  saveSuccessTitle: 'platform.app.invitations.exhibitorDrawerUpdateSuccessTitle',
  saveSuccessMessage: 'platform.app.invitations.exhibitorDrawerUpdateSuccessMessage',
  saveFailureTitle: 'platform.app.invitations.exhibitorDrawerUpdateFailureTitle',
  saveFailureMessage: 'platform.app.invitations.exhibitorDrawerUpdateFailureMessage',
});

export const viewingRoomsMessages = defineMessages({
  createNew: 'platform.app.activations.viewingRooms.createNew',
  createNewArtBasel: 'platform.app.activations.viewingRooms.createNewArtBasel',
  viewingRoom: 'platform.app.activations.viewingRooms.viewingRoom',
  viewingRoomArtBasel: 'platform.app.activations.viewingRooms.viewingRoomArtBasel',
  private: 'platform.app.activations.viewingRooms.status.private',
  public: 'platform.app.activations.viewingRooms.status.public',
  privateTitle: 'platform.app.activations.viewingRooms.status.private.title',
  publicTitle: 'platform.app.activations.viewingRooms.status.public.title',
  publicDescription: 'platform.app.activations.viewingRooms.status.public.description',
  privateDescription: 'platform.app.activations.viewingRooms.status.private.description',
  name: 'platform.app.activations.viewingRooms.settings.name',
  url: 'platform.app.activations.viewingRooms.settings.url',
  access: 'platform.app.activations.viewingRooms.settings.access',
  create: 'platform.app.activations.viewingRooms.actions.create',
  createArtBasel: 'platform.app.activations.viewingRooms.actions.createArtBasel',
  modalDescription: 'platform.app.activations.viewingRooms.publish.modalDescription',
  modalTitle: 'platform.app.activations.viewingRooms.publish.modalTitle',
  emptyStateTitle: 'platform.app.activations.viewingRooms.emptyState.title',
  emptyStateTitleArtBasel: 'platform.app.activations.viewingRooms.emptyState.titleArtBasel',
});

export const audienceMessages = defineMessages({
  audience: 'platform.app.activations.audience.audience',
  private: 'platform.app.activations.audience.status.private',
  public: 'platform.app.activations.audience.status.public',
  inviteAudience: 'platform.app.activations.audience.inviteAudience',
  export: 'platform.app.activations.audience.export',
  visitor: 'platform.app.activations.audience.visitor',
  inquiries: 'platform.app.activations.audience.inquiries',
  transactions: 'platform.app.activations.audience.transactions',
  status: 'platform.app.activations.audience.status',
  description: 'platform.app.activations.audience.description',
  descriptionArtBasel: 'platform.app.activations.audience.descriptionArtBasel',
  emptyStateDescription: 'platform.app.activations.audience.emptyStateDescription',
  emptyStateDescriptionArtBasel: 'platform.app.activations.audience.emptyStateDescriptionArtBasel',
  title: 'platform.app.activations.audience.title',
  inviteAudienceTitle: 'platform.app.activations.audience.inviteAudienceTitle',
  cancelModalButton: 'platform.app.activations.audience.cancelModalButton',
  addAudience: 'platform.app.activations.audience.addVisitors',
  audienceAddedSuccessTitle: 'platform.app.activations.audience.addedSuccessTitle',
  audienceAddedSuccessMessage: 'platform.app.activations.audience.addedSuccessMessage',
  addAudienceErrorTitle: 'platform.app.activations.audience.addAudienceErrorTitle',
  addAudienceErrorMessage: 'platform.app.activations.audience.addAudienceErrorMessage',
});
